import { Typography } from "@timeedit/ui-components";
import { translations } from "@timeedit/registration-shared";
import "./waitlist.scss";
import Queue from "@timeedit/ui-components/icons/Queue";

type WaitlistNotificationProps = {
  useText?: boolean;
};

export function WaitlistNotification({
  useText,
}: WaitlistNotificationProps): React.JSX.Element {
  return (
    <div>
      <Queue alt="Waitlist" className="waitlist-notification__svg" />
      {useText && (
        <Typography.Text className="waitlist-notification__text">
          {translations.inWaitlist}
        </Typography.Text>
      )}
    </div>
  );
}
